module.exports = __webpack_public_path__ + "img/email.0116880f.svg";